import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const trello = defineConnector({
  identifier: "trello",
  name: "Trello",
  tagLine: "Visual project management",
  keywords:
    "atlassian kanban boards cards lists project management task tracking",
  logo,
  protocol: "http",
  tags: ["featured", "productivity"],
  defaultUrlPattern: () => "https://api\\.trello\\.com/.*",
  auth: (app) =>
    queryAuth([
      { name: "key", value: app.secret.apiKey },
      { name: "token", value: app.secret.token },
    ]),
  steps: [
    {
      title: "Get your API key and token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Trello Power-Ups admin page](https://trello.com/power-ups/admin) to generate an API key. Then use the key to authorize and get a token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Trello API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Trello token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.trello.com/1/members/me",
  },
});
